import { useNavigate } from "react-router-dom";
import "./ThankYouPage.styled.css";

function ThankYouPage() {
  const navigate = useNavigate();

  return (
    <div className="thankyou-container">
      <div className="thankyou-card">
        <div className="thankyou-icon">✅</div>

        <div className="thankyou-title">
          Test submitted successfully
        </div>

        <div className="thankyou-message">
          Thank you for completing the assessment.
          <br />
          Our HR team will review your results and contact you soon.
        </div>

        <div className="thankyou-actions">
          <button
            className="thankyou-button"
            onClick={() => navigate("/")}
            type="button"
          >
            Back to homepage
          </button>
        </div>

        <div className="thankyou-note">
          You may safely close this tab.
        </div>
      </div>
    </div>
  );
}

export default ThankYouPage;
